import { Alert } from 'antd';
import React from 'react';

import { type AppRouteKey } from '@/app/routes';
import { UserProfilePage } from '@/components/pages/UserProfilePage';
import { WorkspacePage } from '@/components/pages/WorkspacePage';
import type { AuthenticatedUser } from '@/models/auth.model';

export interface AnalysisPageRouterProps {
  routeKey: AppRouteKey;
  accessToken: string | null;
  user: AuthenticatedUser | null;
}

export const AnalysisPageRouter: React.FC<AnalysisPageRouterProps> = ({ routeKey, user }) => {
  switch (routeKey) {
    case 'workspace':
      return <WorkspacePage />;
    case 'settings-profile':
      return user ? (
        <UserProfilePage user={user} />
      ) : (
        <Alert type="warning" showIcon message="Missing user profile" />
      );
    default:
      return (
        <Alert
          type="warning"
          showIcon
          message="Route not found"
          description="Redirecting to home. If this persists, refresh the page."
        />
      );
  }
};
